
import {
    DATOS_PERSISTIDOS_REQUEST,
    DATOS_PERSISTIDOS_SUCCESS,
    DATOS_PERSISTIDOS_FAIL,
} from '../../actions/Dashboard/types';


// Define el tipo para el estado inicial
interface obtenerInventarioState {
    loading: boolean;
    error: string | null;
    anio: number;

};

// Estado inicial tipado
const initialState: obtenerInventarioState = {
    loading: false,
    error: null,
    anio: 0
};


// Reducer con tipos definidos
const datosPersistidosReducers = (state = initialState, action: any): obtenerInventarioState => {
    switch (action.type) {
        case 'SET_ANIO':
            return { ...state, anio: action.payload };

        case DATOS_PERSISTIDOS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DATOS_PERSISTIDOS_SUCCESS:
            return {
                ...state,
                loading: false,
                anio: action.payload.anio
            };
        case DATOS_PERSISTIDOS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error || 'Error desconocido', // Mejor manejo de errores
            };
        default:
            return state;
    }
};



export default datosPersistidosReducers;
